import { render, staticRenderFns } from "./liveDes2.vue?vue&type=template&id=fd02aae2&scoped=true"
import script from "./liveDes2.vue?vue&type=script&lang=js"
export * from "./liveDes2.vue?vue&type=script&lang=js"
import style0 from "./liveDes2.vue?vue&type=style&index=0&id=fd02aae2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd02aae2",
  null
  
)

export default component.exports